<!--城市组件-->
<template>
  <el-cascader :options="dataList" @change="handleItemChange" :props="props" v-model="result" change-on-select placeholder="请选择城市" style="width:100%;"></el-cascader>
</template>

<script>
import { fetchCity, setCity } from '@/api/base' // 按照昵称查询用户接口
export default {
  name: 'City',
  props: {
    value: null
  },
  data: () => ({
    props: {
      value: 'id',
      label: 'name',
      children: 'children'
    },
    changed: false, // 用户是否手动修改过
    dataList: [{ name: '全部', type: 1, id: -1 }],
    result: []
  }),
  watch: {
    value: function(value) {
      value && !this.changed && this.setCity(value)
      this.changed = false
    }
  },
  methods: {
    handleItemChange(val) {
      this.changed = true

      let id = val.slice().pop()
      // 设置城市子集
      this.cityChildren(id, this.dataList)
      // 更新组件value
      this.$emit('input', id)
      this.$emit('change', id)
    },
    // 城市子集
    cityChildren(id, datas) {
      if (!datas || !datas.length) {
        return false
      }
      datas.forEach(item => {
        if (item.id === id) {
          ;(!item.children || !item.children.length) &&
            this.getCity(++item.type, item.id).then(dataList => {
              item.children = dataList.length ? dataList : null
            })
          return false
        } else {
          this.cityChildren(id, item.children)
        }
      })
    },
    // 获取城市
    getCity(type = 1, parentId = null) {
      let param = { type, parentId }
      return fetchCity(param).then(response => {
        let dataList = response.data.list || []
        return dataList
        // let result = []
        // if (dataList.length) {
        //   result = dataList.map(item => {
        //     item.children = []
        //     return item
        //   })
        // }
        // return result
      })
    },
    // 设置城市
    setCity(id) {
      this.result.length = 0
      setCity({ cityId: id }).then(response => {
        let citys = response.data
        let setCityChildren = (city, datas) => {
          if (city) {
            this.result.push(city.id)
            datas.forEach(item => {
              if (item.id === city.id) {
                this.getCity(++city.type, city.id).then(dataList => {
                  item.children = dataList.length ? dataList : null
                  city.country && setCityChildren(city.country, dataList)
                })
              }
            })
          }
        }
        setCityChildren(citys, this.dataList)
      })
    }
  },
  created() {
    let hasValue = !!this.value
    // 默认国家设置
    if (this.value === -1) {
      this.result.push(this.value)
    }
    this.getCity().then(dataList => {
      this.dataList = this.dataList.concat(dataList)
      hasValue && this.setCity(this.value)
    })
  }
}
</script>
